import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const UsingLaptopIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g>
      <path
        d="M 147.395833 313.020833 C 39.84375 313.020833 42.317708 313.020833 87.109375 209.505208 L 87.109375 275.455729 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 324.544271 227.929688 C 304.427083 227.213542 195.442708 226.236979 187.565104 234.179688 C 176.171875 245.507813 147.981771 324.088542 159.244792 339.127604 C 235.872396 340.625 293.75 342.1875 305.078125 337.630208 C 310.9375 335.286458 315.625 328.580729 318.229167 322.460938 C 320.3125 317.643229 341.927083 244.270833 341.927083 242.252604 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 155.598958 338.476562 C 139.388021 332.356771 122.395833 326.953125 106.835938 318.945312 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 109.309896 124.869792 C 83.984375 207.942708 197.135417 243.164063 227.083333 159.635417 C 243.359375 114.322917 188.671875 47.65625 132.682292 97.721354 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 187.695312 157.8125 C 188.736979 155.013021 189.453125 153.320312 190.039062 150.651042 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 164.322917 157.291667 C 165.429688 155.078125 165.559896 153.059896 166.015625 150.520833 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
    </g>
  </SvgIcon>
);

export default UsingLaptopIcon;
